export function AllTickets({ active = false }: any) {
  const color = active ? "#006AB3" : "#84818A";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1872 18.0724H6.34852C3.69693 18.0724 1.9292 16.75 1.9292 13.6645V7.49354C1.9292 4.40805 3.69693 3.08569 6.34852 3.08569H15.1872C17.8388 3.08569 19.6065 4.40805 19.6065 7.49354V13.6645C19.6065 16.75 17.8388 18.0724 15.1872 18.0724Z"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1873 7.93408L12.4208 10.138C11.5104 10.8609 10.0167 10.8609 9.10629 10.138L6.34863 7.93408"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
